import gql from 'graphql-tag';

export const UpdatePassword = gql`
  mutation updatePassword($updatePassword: UserSetPassword!) {
    updatePassword(updatePassword: $updatePassword) {
      id
    }
  }
`;

export const SetPassword = gql`
  mutation setPassword($token: String!, $password: String!, $phone: String) {
    setPassword(token: $token, password: $password, phone: $phone)
  }
`;
